import { post } from "./api";

export const createCheckoutSession = (customer_id, data) => {
  return post(`/api/v2/stripe-checkout-session/${customer_id}/`, data);
};
